import { AppData, Img, Lightning, Log, Router } from '@lightningjs/sdk'
import { AppApiConfig } from '../lib/app-api-config'
import { AppSetup } from '../lib/app-setup'
import AppModel from '../lib/models/app-model'
import { Logger } from '../lib/logger'
import { Helper } from '../lib/helper'
import { PLATFORM } from '../lib/enum'

export interface SplashTemplateSpec extends Lightning.Component.TemplateSpec {
  Background: object
  NodeNotFoundMsgBox: object
  activIndexLoad: Function
}

export interface SplashTypeConfig extends Lightning.Component.TypeConfig {
  IsPage: true
}

export default class Splash
  extends Lightning.Component<SplashTemplateSpec, SplashTypeConfig>
  implements Lightning.Component<SplashTemplateSpec>
{
  Background = this.getByRef('Background')!

  static override _template(): Lightning.Component.Template<SplashTemplateSpec> {
    const { appConfig } = AppData as AppSetup
    const path = `${appConfig?.resouceUrl}splash-${appConfig?.siteId}.jpg`
    Log.info('Splash Path:', path)
    return {
      ...super._template(),
      w: 1920,
      h: 1080,
      color: 0xff222222,
      Background: {
        w: 1920,
        h: 1080,
        texture: Img(path).contain(1920, 1080),
      },
      NodeNotFoundMsgBox: {
        w: (w: any) => w,
        h: (h: any) => h,
        color: 0xee000000,
        rect: true,
        flex: { alignItems: 'center', justifyContent: 'center' },
        MsgBox: {
          text: {
            text: "Sorry, the title you're looking for is no longer available, but we're loading similar titles for you, hope you like it!",
            wordWrapWidth: 600,
            fontFace: "SFPro-Black",
            letterSpacing: 0.82,
            lineHeight: 47,
            fontSize: 36,
          }
        },
        visible: false
      }
    }
  }

  override _getFocused():
    | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
    | null
    | undefined {
    return this
  }

  override _handleRight(e: KeyboardEvent): boolean | void {
    Log.info('_handleRight')
    return true
  }
  
  /* Fix for XFIN-1108 */
  override _handleBack(e: KeyboardEvent): boolean | void {
    Log.info('_handleBack from Splash Screen')
    const { appConfig, appState, platform } = AppData as AppSetup
    const app: AppModel | undefined = appState?.getApp()
    app?.deeplink.loadPageAfterDeeplink() 
  }
  /* Fix for XFIN-1108 */

  override _onDataProvided(): void {
    Log.info('On Data Provided')
  }
  override _init() {
    const { appConfig, appState, platform } = AppData as AppSetup
    Log.info('splashScreen: _firstEnable', appState?.getApp(), platform)
    const app: AppModel | undefined = appState?.getApp()
    const appApiConfig: AppApiConfig | undefined = appState?.getAppApiConfig()
    platform?.initialize()
      .then(() => {
        // Fix for XFIN-1073
        appConfig.sessionId = Helper.generateSessionId();
        Log.info('splashScreen: sessionId', appConfig.sessionId)
        // Fix for XFIN-1073
        Logger.processUserAction('buildInitialized', '')
        let isOld = Helper.isOldDevice();
        Logger.processUserAction('oldDeviceCheck '+isOld, '')
        Log.info('splashScreen: device model ', platform?.getFullModel())
        if(!platform?.getFullModel()){
          Logger.processUserAction('Not able to identify device full model, bypass freewheel and use ima','')
          appConfig.adSdkToUse = 'ima';
          Log.info('splashScreen: adSdkToUse ', appConfig.adSdkToUse)
        }
        Log.info('splashScreen: is old device ', isOld)
        if(isOld==1){
          Logger.processUserAction('Device model is old, bypass freewheel and use ima', '')
          appConfig.adSdkToUse = 'ima';
          Log.info('splashScreen: adSdkToUse ', appConfig.adSdkToUse)
        }
        if(appConfig?.platform_id == PLATFORM.COX || appConfig?.platform_id == PLATFORM.ROGERS || appConfig?.platform_id == PLATFORM.SHAW) {
           appConfig.adSdkToUse = 'ima';
        }
        app?.loadIndex()?.then(async (success) => {
          Log.info('splashScreen: Index Loaded', success)
          Logger.processUserAction('appLaunched', '')
          platform.sendMetrics('launch', '')
          const { appConfig, appState } = AppData as AppSetup;
          const appApiConfig = appState?.getAppApiConfig()
          let coppa = "false";
          const genre = appApiConfig?.appConfig?.genre
          Log.info('splashScreen: genre ', genre)
          if(genre && genre.toLocaleLowerCase() !== 'movies'){
            appConfig.adSdkToUse = 'ima';
            Log.info('splashScreen: use ima sdk for ads non movies app')
            coppa = "true";
          }
          //Fix for XFIN-943 start
          if(appConfig.adSdkToUse != 'ima'){
            try{
              let adConfig = await platform.getAdConfig({"environment":"prod","authenticationEntity":"MVPD", "coppa":coppa});
              Log.info('splashScreen: adConfig ', adConfig)
              if(adConfig && (adConfig.adNetworkId || adConfig.adNetworkID)){
                Logger.processUserAction('Ad Config is valid', '')
              } else {
                appConfig.adSdkToUse = 'ima';
                Logger.processUserAction('Ad Config is null, bypass freewheel and use ima', '')
              }
            } catch(e){
              appConfig.adSdkToUse = 'ima';
              Logger.processUserAction('Platform Ad Config API Error, bypass freewheel and use ima ' + e, '')
            }            
          }          
          Log.info('splashScreen: adSdkToUse ', appConfig.adSdkToUse)
          //Fix for XFIN-943 end

          //fix for xfin-1414 - start
          const app = appState?.getApp();
          if(appConfig.adSdkToUse == 'ima'){
            if(app && app.adObj && app.adObj.adsdklist && app.adObj.adsdklist.length == 0){
              appConfig?.disableAds = true;
            }
          }
          //fix for xfin-1414 - end


          let playIdUrl = await platform.getPlatformDeeplinkData()
          if (!Helper.isEmpty(playIdUrl)) {
            
            const deeplink = app.deeplink;
            deeplink.getDeeplinkingParams(playIdUrl, this);
            if (appState.playlistPlayMode && !appState.deeplinks.isInvalidPattern) {
              deeplink.loadPlaylistAndPlay();
              appState.isDeeplinkInterupped = true;
            } else {
              deeplink.handleError();
            }
          } else {
            Logger.logSourceInfo()
            if (appConfig?.enableSelectScreen && appApiConfig?.appConfig?.displaySelectScreen) {
              //Logger.processUserAction('splash', '')
              if(appApiConfig?.appConfig?.selectscreen?.noOfRow === 1){
                Router.navigate('select-screen/', false)
              } else if(appApiConfig?.appConfig?.selectscreen?.noOfRow === 2){
                Router.navigate('two-row-select-screen/', false)
              }
            } else {
              Router.navigate('main-grid-screen/' + 0, false)
            }
          }

        })
      })
  }

  showHideMessage(visible: boolean) {
    this.patch({
      NodeNotFoundMsgBox: {
        visible: visible,
      }
    })
  }
}
